import StatTile, { StatTone } from '@components/Common/StatTile';
import React from 'react';

export type KpiTone = 'primary' | 'indigo' | 'teal' | 'amber' | 'success' | 'danger';

interface KpiTileProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  tone: KpiTone;
}

/**
 * The analytics tiles' original API, kept so existing call sites keep compiling. It draws
 * Common/StatTile, which is where new code should go.
 *
 * The four decorative tones (primary, indigo, teal, amber) gave each tile its own hue for no
 * reason a reader could recover, so they all render neutral now. `success` and `danger` are
 * state and keep their colour.
 */
const STATE: Partial<Record<KpiTone, StatTone>> = { success: 'success', danger: 'danger' };

const KpiTile: React.FC<KpiTileProps> = ({ label, value, icon, tone }) => (
  <StatTile label={label} value={value} icon={icon} tone={STATE[tone] ?? 'neutral'} />
);

export default KpiTile;
